module["exports"] = ["+351 91#######", "+351 93#######", "+351 96#######"];